'use client'
import { __awaiter } from '../../../../_virtual/_tslib.js';
import { parse } from 'tldts';

const createBrowserPlatformService = (window) => ({
    getDisplayOrigin: () => window.location.origin,
    getHost: () => window.location.host,
    getHostname: () => window.location.hostname,
    getOrigin: () => window.location.origin,
    getTLD: (domain) => {
        // Passing the allowPrivateDomains option prevents returning the actual TLD
        // for domains that have delegated subdomains like herokuapp.com or s3.amazonaws.com
        // full list is contained here https://publicsuffix.org/list/effective_tld_names.dat
        // separated by ICANN DOMAINS and PRIVATE DOMAINS
        // so for instance parse('someapp.herokuapp.com') will return 'someapp.herokuapp.com' as the domain
        // whereas parse('app.dynamic.xyz') will return 'dynamic.xyz'
        const data = parse(domain || window.location.hostname, {
            allowPrivateDomains: true,
        });
        return data.domain || undefined;
    },
    getUrl: () => new URL(window.location.href),
    isNativeMobile: false,
    openURL: (url_1, ...args_1) => __awaiter(void 0, [url_1, ...args_1], void 0, function* (url, target = 'self', features = '') {
        if (target === 'blank') {
            window.open(url, '_blank', features);
        }
        else {
            window.location.assign(url);
        }
    }),
});

export { createBrowserPlatformService };
